var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Prop, Vue } from 'vue-property-decorator';
/*
If a goalset is added to a group. This component filters on showing only the goals in a group which are attached to a goalset or also other personal goals of the students in the group.
*/
let GoalsetSelect = class GoalsetSelect extends Vue {
    constructor() {
        // #region @VModel
        // #endregion
        super(...arguments);
        // #endregion
        // #region @Refs
        // #endregion
        // #region Class properties
        this.selectedGoalsetOnly = this.value;
        // #endregion
        // #region Lifecycle Hooks
        // #endregion
        // #region Event handlers
        // #endregion
        // #region Class methods
        // #endregion
        // #region Async methods (api calls only)
        // #endregion
        // #region Getters & Setters
        // #endregion
        // #region @Watchers
        // #endregion
    }
    onSelected(selectedGoalsetOnly) {
        this.$emit('input', selectedGoalsetOnly);
    }
};
__decorate([
    Prop({ default: true }),
    __metadata("design:type", Boolean)
], GoalsetSelect.prototype, "value", void 0);
__decorate([
    Prop({ required: true }),
    __metadata("design:type", Array)
], GoalsetSelect.prototype, "items", void 0);
GoalsetSelect = __decorate([
    Component({})
], GoalsetSelect);
export default GoalsetSelect;
// #endregion
// #region Constants
// #endregion
